import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { installFetchCsrfHeader } from "./lib/install-fetch-csrf-header";
import { initSentry } from "./lib/sentry";

// Initialise error reporting BEFORE rendering so render-phase failures
// in the very first frame are captured. No-op when VITE_SENTRY_DSN is unset.
initSentry();

installFetchCsrfHeader();

createRoot(document.getElementById("root")!).render(<App />);
